/*
 * 客要望（2026-08-13 ②・図面1）: サイト内のリンクを新しいタブで開き、元のページを残す。
 *
 *   「リッチテキストエディタのリンク設定で『このリンクを開く場所』を『新しいウィンドウ』に。
 *     サイト内のリンク先へ移動された後、元ウィンドウがブラウザ上に残るように」（全ページ）
 *
 * リンクを 1 本ずつ設定して回ると設定漏れが出るうえ、商品やページを足すたびに再発するので、
 * テーマ側でまとめて target="_blank" を付ける。
 *
 * ただし**買い物のための操作**まで新しいタブにすると購入体験が壊れる
 * （カートやチェックアウトがタブに増える・戻る操作が効かなくなる）ため、下記は除外する。
 *
 *   ・ヘッダー（メニュー・検索・アカウント・カートのアイコン）とモバイルのメニュー
 *   ・カート／チェックアウト／アカウント（新しい顧客アカウントの customer_authentication を
 *     含む）／パスワード等、操作そのものが目的の遷移先
 *   ・カートの明細・削除、カート通知、クイック追加
 *   ・ページ送り（ページネーション）と絞り込み・並び替え
 *   ・ページ内アンカー（#）、メール（mailto:）、電話（tel:）、ダウンロード指定
 *
 * 逆に新しいタブで開くのは「読むためのリンク」= ページ本文（<main>）の中すべてと、
 * フッターのリンク集（特定商取引法・プライバシーポリシー等の参照ページ）。
 */
(function () {
  'use strict';

  // 新しいタブにする範囲。ページ本文とフッターのリンク集。
  var INCLUDE = ['#MainContent a[href]', '.footer-block--menu a[href]'].join(',');

  // 除外する入れ物（この中のリンクは同じタブのまま）。
  var EXCLUDE_CONTAINERS = [
    '.header-wrapper', // ヘッダー全体（メニュー・検索・アカウント・カート）
    '.menu-drawer', // モバイルのメニュー
    'cart-drawer', // カートドロワー
    '#cart-notification', // 「カートに追加しました」の通知
    '.cart-item', // カートの明細行
    'cart-remove-button', // カートの削除ボタン
    'quick-add-modal', // クイック追加
    '.facets', // 絞り込み
    'facet-filters-form',
    '.active-facets', // 適用中の絞り込みの解除
    '.pagination', // ページ送り
    '.footer__content-bottom' // ポリシー・決済アイコン・著作権
  ].join(',');

  // 除外する遷移先（操作そのものが目的のパス）。
  // customer_authentication / customer_identity は「新しい顧客アカウント」のログイン導線。
  // カートが空のときの「ログイン」リンクが本文（#MainContent）に出るので、パスで弾く。
  var EXCLUDE_PATH = /^\/(cart|checkout|account|customer_authentication|customer_identity|password|challenge|localization|apps|services|tools)(\/|$)/;
  var EXCLUDE_PROTOCOL = /^(mailto|tel|sms|javascript):/i;

  function shouldOpenInNewTab(a) {
    if (a.target) return false; // 既に指定があるものは尊重する
    if (a.hasAttribute('download')) return false;

    var raw = a.getAttribute('href');
    if (!raw || raw.charAt(0) === '#' || EXCLUDE_PROTOCOL.test(raw)) return false;
    if (a.closest(EXCLUDE_CONTAINERS)) return false;

    var url;
    try {
      url = new URL(a.href, window.location.origin);
    } catch (e) {
      return false;
    }
    if (url.origin === window.location.origin && EXCLUDE_PATH.test(url.pathname)) return false;
    return true;
  }

  function apply() {
    document.querySelectorAll(INCLUDE).forEach(function (a) {
      if (!shouldOpenInNewTab(a)) return;
      a.setAttribute('target', '_blank');
      // 新しいタブから元のタブを触れないようにする（target="_blank" の定番の手当て）
      var rel = (a.getAttribute('rel') || '').split(/\s+/).filter(Boolean);
      if (rel.indexOf('noopener') === -1) rel.push('noopener');
      a.setAttribute('rel', rel.join(' '));
    });
  }

  // 絞り込み・ページ送り・クイック追加などは JS で中身を差し替えるため、
  // 差し替わったリンクにも付け直す。属性の変更は監視しないので無限ループにはならない。
  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      apply();
    });
  }

  apply();
  new MutationObserver(schedule).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
